const RECORDING_INTAKE_UNKNOWN_BUCKET_CODE = "unknown_bucket";
const RECORDING_INTAKE_INTAKE_DISABLED_CODE = "intake_disabled";
const RECORDING_INTAKE_FILE_NOT_FOUND_CODE = "file_not_found";
const RECORDING_NO_ROUTING_RULE_MATCHED_MESSAGE = "No routing rule matched for the teammate";
const RECORDING_TEAMMATE_DEACTIVATED_CODE = "teammate_deactivated";
const RECORDING_ANALYZED_MINUTES_LIMIT_CODE = "analyzed_minutes_limit_reached";
const RECORDING_MEDIA_URL_UNAVAILABLE_CODE = "media_url_unavailable";
const RECORDING_MEDIA_URL_REJECTED_CODE = "media_url_rejected";
const sharedRecordingImportErrorLabels = {
  no_routing_for_teammate: "No routing for teammate",
  [RECORDING_TEAMMATE_DEACTIVATED_CODE]: "Teammate deactivated",
  [RECORDING_ANALYZED_MINUTES_LIMIT_CODE]: "Analyzed minutes limit reached",
  [RECORDING_MEDIA_URL_UNAVAILABLE_CODE]: "Media URL unreachable",
  [RECORDING_MEDIA_URL_REJECTED_CODE]: "Media URL rejected"
};
const RECORDING_INTAKE_NO_ERROR_CODE_KEY = "__none__";
const recordingIntakeVendors = ["five9", "ringcentral"];
const RECORDING_BUCKET_PATTERN = /^alpharun-(five9|ringcentral)-recordings-([a-z0-9-]+?)-([a-z]{2}-[a-z]+-\d)$/;
function parseRecordingIntakeBucketName(bucket) {
  const match = RECORDING_BUCKET_PATTERN.exec(bucket);
  if (!match) {
    return null;
  }
  const [, vendor, slug, region] = match;
  if (!vendor || !slug || !region || !recordingIntakeVendors.includes(vendor)) {
    return null;
  }
  return { vendor, slug, region };
}
function recordingS3IntakeProviderForVendor(vendor) {
  switch (vendor) {
    case "five9":
      return "five9_recording_s3_intake";
    case "ringcentral":
      return "ringcentral_recording_s3_intake";
  }
}
export {
  RECORDING_ANALYZED_MINUTES_LIMIT_CODE,
  RECORDING_INTAKE_FILE_NOT_FOUND_CODE,
  RECORDING_INTAKE_INTAKE_DISABLED_CODE,
  RECORDING_INTAKE_NO_ERROR_CODE_KEY,
  RECORDING_INTAKE_UNKNOWN_BUCKET_CODE,
  RECORDING_MEDIA_URL_REJECTED_CODE,
  RECORDING_MEDIA_URL_UNAVAILABLE_CODE,
  RECORDING_NO_ROUTING_RULE_MATCHED_MESSAGE,
  RECORDING_TEAMMATE_DEACTIVATED_CODE,
  parseRecordingIntakeBucketName,
  recordingIntakeVendors,
  recordingS3IntakeProviderForVendor,
  sharedRecordingImportErrorLabels
};
//# sourceMappingURL=recordingIntake.js.map
